import { Component, Input } from '@angular/core';

@Component({
  selector: 'zoom-button',
  templateUrl: './zoom-button.component.html',
  styleUrls: ['./zoom-button.component.scss'],
})
export class ZoomButtonComponent {
  @Input() useThemeColor;
}
